/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { FunctionComponent, JSX } from "react";

import type { BadgeProps } from "./BadgeProps";
import "./Badge.scss";

/**
 * Renders a compact inline text badge (e.g. "NEW", "TV-MA").
 *
 * @param props.text       - The label text to display inside the badge.
 * @param props.classStyle - For customization of the badge's CSS class.
 */
const Badge: FunctionComponent<BadgeProps> = (
  props: BadgeProps
): JSX.Element | null => {
  const TAG: string = "Badge";
  const { text, classStyle = "" } = props;

  const baseClass: string =
    "badge" + (classStyle !== "" ? " " + classStyle : "");

  return (
    <span className={baseClass} data-tag={TAG}>
      {text}
    </span>
  );
};

export default Badge;
